{{#if label}}
<label class="tool-label" title="{{#if description}}{{description}}{{/if}}">
  {{ label }}
</label>
{{/if}}
